<script setup lang="ts">
import { useToast } from './toast.ts';

const { toasts, dismiss } = useToast();
const TONES = { success: 'border-success/40 bg-success-soft', danger: 'border-danger/40 bg-danger-soft', info: 'border-border bg-surface' } as const;
</script>

<template>
  <div class="pointer-events-none fixed right-4 bottom-4 z-[60] flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-2" aria-live="polite">
    <button
      v-for="toast in toasts"
      :key="toast.id"
      type="button"
      :class="['pointer-events-auto rounded-lg border px-4 py-3 text-left text-sm shadow-lg', TONES[toast.tone]]"
      :role="toast.tone === 'danger' ? 'alert' : 'status'"
      @click="dismiss(toast.id)"
    >
      {{ toast.message }}
    </button>
  </div>
</template>
